import {
  BALANCE_SUCCESS,
  LOGIN_SUCCESS,
  LOGOUT,
  EXPOSURE_AMOUNT,
  ORIGIN_RESTRICTION,
  PLAYER_PROFILE,
} from "./types";
import {
  axiosService,
  removeUserToken,
  setUserToken,
} from "../../utils/axiosService";
import { API_URLS } from "../../config/apiUrls";
import { Toaster } from "../../utils/toaster";
import {
  AFF_KEY_LS,
  APP_CONST,
  PASSWORD_UPDATE_TYPE,
  UPDATE_PASSWORD_FLAG_KEY,
} from "../../config/const";
import { socketFunc } from "../../utils/socketUtil";
import axios, { AxiosError } from "axios";
const sportsBaseUrl = process.env.REACT_APP_SPORTS_HOST;

// login user
export const loginUser = (payload) => (dispatch) => {
  try {
    const result = axiosService.post(API_URLS.AUTH.LOGIN_USER, payload);
    result
      .then((res) => {
        if (res.data.error === false) {
          // Get profile with real time token
          dispatch(getProfile(res?.data?.data?.token));
          // Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Login Success");

          socketFunc(res?.data?.data?.token).emit("get:balance", (data) => {
            if (data?.status === "success") {
              // console.log("sock func", data);
              dispatch(balanceUpdate(data));
            }
          });

          dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data.data,
          });

          if (
            res?.data?.data?.extras?.passwordUpdateRequired === true &&
            res?.data?.data?.extras?.paswordUpdateType ==
              PASSWORD_UPDATE_TYPE.type0
          ) {
            localStorage.setItem(UPDATE_PASSWORD_FLAG_KEY, true);
          }
          setUserToken(res.data.data.token);
          // window.location.reload();
        } else {
          Toaster(APP_CONST.TOAST_TYPE.ERROR, "Login Failed");
        }
      })
      .catch((err) => {
        Toaster(
          APP_CONST.TOAST_TYPE.ERROR,
          err?.response?.data?.message || "Login Failed",
        );
      });
  } catch (err) {
    Toaster(APP_CONST.TOAST_TYPE.ERROR, "Login Failed");
    console.debug(err);
  }
};

//register User

export const registerUser = (paylaod, scriptLoad) => (dispatch) => {
  try {
    const result = axiosService.post(API_URLS.AUTH.REGISTER_USER, paylaod, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    result
      .then((res) => {
        localStorage.removeItem(AFF_KEY_LS);

        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Player added");
        // Get profile with real time token
        dispatch(getProfile(res?.data?.data?.token));
        localStorage.removeItem("mobile_details");
        dispatch({
          type: LOGIN_SUCCESS,
          payload: res?.data?.data,
        });
        setUserToken(res.data.data.token);
        scriptLoad();
      })
      .catch((err) => {
        const message =
          err?.response?.data?.message ||
          err?.response?.data?.errorMessage ||
          "Request failed";

        Toaster(APP_CONST.TOAST_TYPE.ERROR, message);
        // Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
      });
  } catch (err) {
    console.debug(err);
  }
};

// send mobile otp
export const sendOtpToMobile = (paylaod) => (dispatch) => {
  try {
    const result = axiosService.post(API_URLS.AUTH.SEND_OTP_TO_MOBILE, paylaod);
    return result;
  } catch (err) {
    console.debug(err);
  }
};

// verify otp
export const mobileVerification = (paylaod) => (dispatch) => {
  try {
    const result = axiosService.post(
      API_URLS.AUTH.MOBILE_VERIFICATION,
      paylaod,
    );
    return result;
  } catch (err) {
    console.debug(err);
  }
};

export const balanceUpdate = (data) => (dispatch) => {
  dispatch({
    type: BALANCE_SUCCESS,
    payload: data,
  });
};

export const logoutUser = () => (dispatch) => {
  try {
    axiosService.get(API_URLS.AUTH.SIGN_OUT);
  } catch (err) {
    console.debug(err);
  }
  dispatch({
    type: LOGOUT,
  });
  removeUserToken();
  window.location.reload();
};

export const getExposureAmount = () => (dispatch) => {
  try {
    const result = axios.get(
      `${sportsBaseUrl}${API_URLS.AUTH.GET_EXPOSURE_AMOUNT}`,
      {
        headers: {
          "xu-auth": sessionStorage.getItem("token"),
        },
      },
    );
    result.then((res) => {
      dispatch({
        type: EXPOSURE_AMOUNT,
        payload: res?.data?.data?.exposureAmount,
      });
    });
  } catch (err) {
    console.debug(err);
  }
};

export const forgotPassword = (paylaod) => {
  try {
    return axiosService.post(API_URLS.AUTH.FORGOT_PASSWORD, paylaod);
  } catch (err) {
    console.debug(err);
  }
};

export const resetPassword = (payload) => {
  try {
    return axiosService.post(API_URLS.AUTH.RESET_PASSWORD, payload);
  } catch (err) {
    console.debug(err);
  }
};

export const updatePassword = async (paylaod) => {
  try {
    return await axiosService.post(API_URLS.AUTH.UPDATE_PASSWORD, paylaod);
  } catch (err) {
    console.debug(err);
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err?.response?.data?.message || "Request failed",
      );
    }
  }
};

// check for existing user

export const checkIfUserNameExist = async (paylaod) => {
  try {
    return await axiosService.post(API_URLS.AUTH.EXISTING_USER, paylaod);
  } catch (err) {
    console.log(err);
  }
};
export const pageVisit = async (payload) => {
  try {
    const result = await axiosService.post(API_URLS.AUTH.PAGE_VISIT, payload);
    return result;
  } catch (err) {
    console.debug(err);
  }
};
// check if demom user exist

export const checkIfDemoUserExist = async () => {
  try {
    return await axiosService.get(API_URLS.APP.GET_APP_DEMO);
  } catch (err) {
    if (err instanceof AxiosError) {
      console.log("err");
    }
  }
};

export const demoLogin = () => async (dispatch) => {
  try {
    const demoLoginResponse = await axiosService.post(API_URLS.AUTH.DEMO_LOGIN);
    if (demoLoginResponse && demoLoginResponse?.data?.error === false) {
      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Login Success");
      // Get profile with real time token
      dispatch(getProfile(demoLoginResponse?.data?.data?.token));
      socketFunc(demoLoginResponse?.data?.data?.token).emit(
        "get:balance",
        (data) => {
          if (data?.status === "success") {
            dispatch(balanceUpdate(data));
          }
        },
      );

      dispatch({
        type: LOGIN_SUCCESS,
        payload: demoLoginResponse.data.data,
      });
      setUserToken(demoLoginResponse.data.data.token);
    }
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err?.response?.data?.message || "Login Failed",
      );
    }
  }
};

export const updateOriginRestriction = (payload) => (dispatch) => {
  dispatch({
    type: ORIGIN_RESTRICTION,
    payload: payload,
  });
};

// Get Profile : Get
export const getProfile = (realTimeToken) => async (dispatch) => {
  try {
    const response = await axiosService.get(API_URLS.USER.PROFILE, {
      headers: {
        Authorization: realTimeToken || sessionStorage.getItem("token"),
      },
    });
    if (response) {
      dispatch({
        type: PLAYER_PROFILE,
        payload: response?.data?.data,
      });
    }
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err.response.data?.message || "Failed to get profile",
      );
    }
  }
};
export const sendOtpToEmail = async (payload) => {
  try {
    return await axiosService.post(API_URLS.AUTH.EMAIL_OTP, payload);
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err?.response?.data?.message || "Request failed",
      );
    }
  }
};

export const verifyEmailOtp = async (payload) => {
  try {
    return await axiosService.post(API_URLS.AUTH.MOBILE_VERIFICATION, payload);
  } catch (err) {
    if (err instanceof AxiosError) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        err?.response?.data?.message || "Request failed",
      );
    }
  }
};
